// extracted by mini-css-extract-plugin
module.exports = {"root":"_3cec79","text":"_e68cf6","bold":"_e70c7e","actions":"_2cd971","advisorPhotoWrapper":"_c094cc","advisorPhoto":"_b39f0f","button":"_f74ec5"};